import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import Supplier from "./Supplier";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../Styles/SupplierSlider.css'
import Carousel from "react-multi-carousel";
import { useCompanyInfo } from "../../../Providers/CompanyInfoProvider";
import { useConfig } from "../../../Providers/ConfigProvider";
import imageExists from "image-exists";
import LoadingSpinner from "../../../Components/Components/LoadingSpinner";
import { useParams } from "../../../Providers/ParamsProvider";

const SupplierSlider = ({ supplierLogoItems }) => {
  const { dataUrl } = useConfig()
  const [validSuppliers, setValidSuppliers] = useState([]);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(true);
  const { isMobile } = useParams()


  useEffect(() => {
    if (supplierLogoItems.length > 0) {
      checkImages()
    } else {
      setIsLoadingSuppliers(false)
    }
  }, [supplierLogoItems, dataUrl]);

  const checkImages = () => {
    setIsLoadingSuppliers(true)
    const validItems = []

    for (const item of supplierLogoItems) {
      imageExists(`${dataUrl}/miniaturki/Dostawcy/${item.logoFileName}`, function (exists) {
        if (exists) {
          validItems.push(item)
        }
      })

    }
    setValidSuppliers(validItems)
    setIsLoadingSuppliers(false)
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 6 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 4,
      slidesToSlide: 4 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 767, min: 100 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    }
  };

  return (
    <div className='container-fluid supplier-slider-bg mt-5'>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <div className="row justify-content-center align-items-center mb-5 mt-5">
            <div className="col-auto me-5">
              <h4 >Nasi dostawcy: </h4>
            </div>
            <div className="col-11 col-md-10 gd-carousel-wrapper">
              {isLoadingSuppliers && <p class="card-text placeholder-glow ms-5"><span class="placeholder col-7"></span></p>}
              {!isLoadingSuppliers && <Carousel
                className="gd-carousel"
                responsive={responsive}
                autoPlay={true}
                swipeable={true}
                draggable={true}
                showDots={isMobile ? false : true}
                infinite={true}
                autoPlaySpeed={5000}
                partialVisbile={false}
                ssr={true}
              >
                {(validSuppliers) && validSuppliers.map(supplierItem => {
                  return <Supplier key={supplierItem.supplierId} image={`${dataUrl}/miniaturki/Dostawcy/${supplierItem.logoFileName}`} supplier={supplierItem} />
                })}
              </Carousel>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SupplierSlider